import MDRouter from "@/service/router";
import { getProLockOrderRelateOrderList, modifyProLockOrderAddress } from "@api/index";
import { mdToast } from "../../utils/tools";
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    gift_order_id: {
      type: String,
      default: ''
    }
  },
  emits: ['update:show', 'refresh'],
  // 声明组件可以触发的事件
  data() {
    return {
      orders: [],
      // 关联订单列表
      loading: false,
      // 加载状态
      selectedIndex: -1 // 选中的订单索引，默认-1
    };
  },
  computed: {
    ifShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      }
    },
    ordersList() {
      return this.orders || [];
    }
  },
  watch: {
    // 监听弹窗显示状态变化，当显示时获取数据
    show(newVal) {
      if (newVal && this.gift_order_id) {
        this.getOrdersList();
      }
    },
    // 监听gift_order_id变化，当ID变化且弹窗显示时获取数据
    gift_order_id(newVal) {
      if (newVal && this.show) {
        this.getOrdersList();
      }
    }
  },
  methods: {
    // 获取关联订单列表
    async getOrdersList() {
      if (!this.gift_order_id) return;
      this.loading = true;
      console.log('this.gift_order_id', this.gift_order_id);
      try {
        const res = await getProLockOrderRelateOrderList({
          "gift_order_id": this.gift_order_id
        });
        console.log('res', res);
        if (res.status === 0 && res.data) {
          this.orders = res.data.list || [];
          res.data.list.forEach((item, index) => {
            if (Number(item.select_type) === 1) {
              this.selectedIndex = index;
            }
          });
        } else {
          console.error('获取关联订单列表失败:', res.message);
          this.orders = [];
        }
      } catch (error) {
        console.error('获取关联订单列表异常:', error);
      } finally {
        this.loading = false;
      }
    },
    closePopup() {
      this.ifShow = false;
    },
    goToOrderDetail(orderId) {
      if (orderId) {
        MDRouter.Link(`/order/detail?order_id=${orderId}`, 'wap');
        this.closePopup();
      }
    },
    getOrderImage(order) {
      if (order && order.image_url) {
        return order.image_url;
      }
      return "";
    },
    maskPhone(phone) {
      if (!phone) return '';
      return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },
    chooseAddress(order, index) {
      this.selectedIndex = index;
    },
    async confirmSelection() {
      if (this.selectedIndex === -1) return;
      try {
        this.loading = true;
        const selectedOrder = this.ordersList[this.selectedIndex];
        const res = await modifyProLockOrderAddress({
          gift_order_id: this.gift_order_id,
          address_order_id: selectedOrder.order_id
        });
        if (res.status === 0) {
          mdToast('地址修改成功');
          this.closePopup();

          // 不用刷新啦
          // this.$emit('refresh'); 
        } else {
          mdToast(res.message || '修改地址失败');
          console.error('修改关联订单地址失败:', res.message);
        }
      } catch (error) {
        mdToast('修改地址失败，请稍后再试');
        console.error('修改地址出现异常:', error);
      } finally {
        this.loading = false;
      }
    }
  }
};